import styled from 'styled-components';

export const StyledHorizontalRule = styled.div`
    ${({ theme, $color, $height }) => `
    width: 100%;
    height: ${$height ? $height : '1px'};
    background-color: ${$color ? theme.palette.common[$color] : theme.palette.common.gray7};
    `}
`;
